module.exports = __webpack_public_path__ + "img/planning.cec81f56.svg";